<template>
  <dialog-v2
    :show="show"
    :title="title"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex :md4="showTypes" :md6="!showTypes">
          <v-text-field
            v-model="form.name"
            v-validate.disable="'required'"
            data-vv-name="name"
            data-vv-scope="botTemplate"
            data-vv-as="nombre"
            color="black"
            label="Nombre"
            :error-messages="errors.collect('botTemplate.name')"/>
        </v-flex>
        <v-flex v-if="showTypes" md4 pl-4>
          <v-select
            v-model="form.type"
            v-validate.disable="'required'"
            data-vv-scope="botTemplate"
            data-vv-as="tipo"
            data-vv-name="type"
            :items="types"
            label="Tipo"
            color="black"
            autocomplete
            :error-messages="errors.collect('botTemplate.type')"
            />
        </v-flex>
        <v-flex :md4="showTypes" :md6="!showTypes" pl-4>
          <v-select
            v-show="form.type !== 'colly'"
            v-model="form.voice"
            :items="voices"
            v-validate.disable="form.type !== 'colly' ? 'required' : ''"
            data-vv-scope="botTemplate"
            data-vv-as="voz"
            data-vv-name="voice"
            label="Voz"
            color="black"
            :error-messages="errors.collect('botTemplate.voice')"
            />
          <v-select
            v-show="form.type === 'colly'"
            v-model="form.bot_voice_id"
            :items="collyVoices"
            :item-value="'id'"
            :item-text="'show_name'"
            v-validate.disable="form.type === 'colly' ? 'required' : ''"
            data-vv-scope="botTemplate"
            data-vv-as="voz1"
            data-vv-name="bot_voice_id"
            label="Voz"
            color="black"
            :error-messages="errors.collect('botTemplate.bot_voice_id')"
            />
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="form.type === 'colly'">
        <v-flex md12>
          <v-text-field
            v-model="form.max_commitment_days"
            v-validate.disable="'required|numeric'"
            data-vv-scope="botTemplate"
            data-vv-as="maximo dias de compromiso"
            data-vv-name="max_commitment_days"
            label="Maximo dias de compromiso"
            color="black"
            :error-messages="errors.collect('botTemplate.max_commitment_days')"
            />
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="form.type === 'colly'">
        <v-flex md12>
          <v-select
            v-model="form.call_list_id"
            data-vv-scope="botTemplate"
            data-vv-as="campaña"
            data-vv-name="call_list_id"
            label="Campaña de redireccion"
            color="black"
            :error-messages="errors.collect('botTemplate.call_list_id')"
            :items="callLists"
            item-value="id"
            item-text="name"
            autocomplete
          />
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import DialogV2 from '@/components/global/DialogV2';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      default() {
        return {
          name: '',
          type: 'payment_promise',
          voice: 'lupe',
          call_list_id: null,
        };
      },
    },
    showTypes: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    const emptyForm = {
      name:                '',
      type:                'colly',
      voice:               '',
      bot_voice_id:        null,
      call_list_id:        null,
      max_commitment_days: 0,
    };
    return {
      collyVoices: [],
      callLists: [
        { id: null, name: 'Cualquiera' },
      ],
      types: [
        {
          value: 'colly',
          text: 'Agente AI',
        },
        // {
        //   value: 'payment_promise',
        //   text: 'Compromiso',
        // },
        // {
        //   value: 'sale',
        //   text: 'Venta',
        // },
        // {
        //   value: 'no_commitment',
        //   text: 'Sin compromiso',
        // },
        // {
        //   value: 'customer_confirmation',
        //   text: 'Confirmacion de cliente',
        // },
        // {
        //   value: 'payment_promise_basic',
        //   text: 'Compromiso (Basico)',
        // },
        // {
        //   value: 'sale_basic',
        //   text: 'Venta (Basico)',
        // },
        // {
        //   value: 'no_commitment_basic',
        //   text: 'Sin compromiso (Basico)',
        // },
        // {
        //   value: 'customer_confirmation_basic',
        //   text: 'Confirmacion de cliente (Basico)',
        // },
        // {
        //   value: 'payment_promise_basic_mail',
        //   text: 'Compromiso con mail (Basico)',
        // },
      ],
      emptyForm,
      form: {
        ...emptyForm,
      },
    };
  },
  created() {
    this.getVoices();
    this.getCallLists();
  },
  computed: {
    currentType() {
      return this.form.type;
    },
    voices() {
      return [
        {
          value: 'lupe',
          text: 'Lupita',
        },
        {
          value: 'ramiro',
          text: 'Ramiro',
        }
      ];
    },
  },
  methods: {
    getVoices() {
      this.axios.get('/bot_voices').then((response) => {
        this.collyVoices = response.data.map(item => ({...item, show_name: `${item.name} (${item.country.iso})`}));
      });
    },
    getCallLists() {
      this.axios.get('/calls_lists?paginate=0&status[]=1&type_id=10').then((response) => {
        this.callLists = [ { id: null, name: 'Cualquiera' }, ...response.data, ];
      });
    },
    save() {
      this.$validator.validateAll('botTemplate').then((validation) => {
        if (validation) {
          this.$emit('save', this.form);
        }
      });
    },
    clearErrors() {
      Object.keys(this.form).forEach((key) => {
        this.$validator.errors.remove(key, 'botTemplate');
      });
    },
  },
  watch: {
    currentType(newVal, oldVal) {
      if (oldVal !== newVal && !(Object.keys(this.data).length)) {
        this.form.voice = '';
      }
    },
    show() {
      if (this.show) {
        this.form = {
          ..._.pick(this.data, Object.keys(this.emptyForm)),
        };
        return this.clearErrors();
      }

      setTimeout(() => {
        this.form = {
          ...this.emptyForm,
        };
        this.clearErrors();
      }, 200);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/bot_v4/BotDialog.vue